import { z } from 'zod';

import { t } from '../i18n/validation.js';
import { DeviceType } from '../types/device-type.js';

export const DeviceFamily = {
  KVITKA: 'kvitka',
  SUNFLOWER: 'sunflower',
} as const;
export type DeviceFamily = (typeof DeviceFamily)[keyof typeof DeviceFamily];

export const deviceFormSchema = z
  .object({
    serialNumber: z.string().trim().min(1, t('validation.device.serialNumberRequired')),
    model: z.enum(
      [DeviceFamily.KVITKA, DeviceFamily.SUNFLOWER] as [DeviceFamily, ...DeviceFamily[]],
      {
        error: t('validation.device.selectFamily'),
      },
    ),
    deviceType: z.nativeEnum(DeviceType).optional(),
  })
  .refine(
    (data) => {
      if (data.model === 'kvitka') {
        return data.deviceType !== undefined;
      }
      return true;
    },
    {
      message: t('validation.deviceSettings.selectDeviceType'),
      path: ['deviceType'],
    },
  );

export type DeviceFormValues = z.infer<typeof deviceFormSchema>;
